import getSdkSession from './utils/getSdkSession';

const Token = {

    /**
     *
     * @returns {Object} - a reference to the SDK session singleton
     *
     */

    getSdkSession,

    /**
     *
     * @access public
     * @desc Returns the current access state from local storage
     * @returns {Promise} Returns a promise that resolves with the user's access state
     *
     */
    async getAccessState() {
        const sdkSession = await Token.getSdkSession();
        return sdkSession.getAccessState();
    },

    /**
     *
     * @access public
     * @desc Gets an access token from SDK Session.
     * @returns {Promise} Resolves with access Token.
     *
     */
    async getAccessToken() {
        const sdkSession = await Token.getSdkSession();
        return await sdkSession.getSessionToken();
    }

};

export default Token;
